import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import {ageComparator} from "../../../../../../components/reports/charts/utils.js";

const reportName = "Abordagens de indivíduos por faixa etária"
const reportId = "individuals-age-range"
const IndividualsAgeRange = ({data}) => {

  useEffect(() => {
    const sortedData = data.sort((elA, elB) => ageComparator(elA.age_range, elB.age_range)).slice(0,5)
    const values = sortedData.map(i => i.qty);
    const labels = sortedData.map(i => i.age_range);

    GraphicUtils.barChart(reportId, values, labels, false);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, "Abord. de ind. por faixa etária");

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName}</span>
        <div className="mt-1" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default IndividualsAgeRange;